module.exports = __webpack_public_path__ + "img/backtotop.6dfc3039.svg";